import { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import throttle from "lodash/throttle";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const throttleTime = 1000; // in ms

const SearchPeopleAutocomplete = ({ handleValueChange, placeholder, ...props }) => {
    const token = useSelector((state) => state.auth.token);
    const [options, setOptions] = useState([]);

    const handleAutocompleteChange = async (event, value) => {
        let query = event.target.value;
        console.log(query);
        if (!query) {
            query = "";
        }
        if (query.length > 0) {
            query = query.trim();
        }
        //setIsTyping(query.length > 0); // exclusively for the loading circular progress wheel
    
        if (query !== "") {
            // clear old options
            setOptions([]);
    
            // fetch new options
            let url = new URL(`${process.env.REACT_APP_PORT}/people/searchPeople`);
            url.searchParams.set("query", query);
            const response = await fetch(url, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await response.json();
            
            if (response.status === 200) {
                console.log(data);
                setOptions(data.results);
            } else {
                console.log("error");
            }
        }
    };
    
    const throttledHandleAutocompleteChange = useMemo(
        () => throttle(handleAutocompleteChange, throttleTime)
    ,[]);

	// Stop the invocation of the throttled function after unmounting
	useEffect(() => {
		return () => {
			throttledHandleAutocompleteChange.cancel();
		};
	}, []);

    return (
        <Autocomplete
            {...props}
            size="small"
            componentsProps={{ popper: { placement: 'bottom-start', style: { width: 300 } } }}
            /* Throttling Autocomplete */
            filterOptions={(x) => x} // disable filtering on client
            onInputChange={throttledHandleAutocompleteChange}
            options={options}
            getOptionLabel={(option) => { return (
                option.name ||
                option.email ||
                option.displayName ||
                'undefined'
            )}}
            onChange={handleValueChange}
            isOptionEqualToValue={(option, value) => {
                return option.email === value.email;
            }}

            renderInput={(params) => (
                <TextField {...params} placeholder={placeholder} variant="standard" />
            )}
            renderOption={(props, option) => (
                <ListItem {...props} key={option.resource} dense>
                    <ListItemAvatar >
                        <Avatar src={option.photo} sx={{ width: 34, height: 34 }}/>
                    </ListItemAvatar>
                    <ListItemText 
                        primary={option.name || option.displayName || option.email || 'undefined' } 
                        secondary={option.email} 
                        primaryTypographyProps={{variant:"h6"}}
                        secondaryTypographyProps={{ variant:"h6", color: 'text.secondary' }}/>
                </ListItem>
            )}
            renderTags={(value, getTagProps) => 
                value?.map((option, index) => (
                    <Chip 
                        key={option.resource}
                        avatar={<Avatar src={option.photo}/>} 
                        variant="outlined"
                        //label={option.email} 
                        label={
                            <Typography 
                                variant="h6"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                width="90px"
                            >
                                {option.email}
                            </Typography>
                        }
                        {...getTagProps({ index })} 
                    />
                ))
            }
        />
    );
};

export default SearchPeopleAutocomplete;
